// HarborWell centralized branding configuration.
//
// SINGLE SOURCE OF TRUTH for the official HarborWell display name,
// logo asset paths, support contact, website, and brand colors.
// Forms and (later) email templates consume these values.
//
// The logo asset lives at /brand/harborwell-logo.png (see
// frontend/public/brand/). It is deliberately not hot-linked from an
// external URL so the frontend can render offline / on preview / in
// production without a runtime dependency on connect.harborwell.care.
//
// Legacy note: `HARBORWELL_LOGO` and `HARBORWELL_MARK` are re-exported
// from @/lib/api for backwards compatibility with older imports; both
// re-exports resolve to the same underlying constants declared here.

const HARBORWELL_LOGO_PATH = "/brand/harborwell-logo.png";
const HARBORWELL_MARK_PATH = "/brand/harborwell-mark.png";

export const BRAND = Object.freeze({
  // Organizational identity
  orgName: "HarborWell",
  productName: "HarborWell Connect",
  legalStatus: "A 501(c)(3) nonprofit",
  region: "Eastern North Carolina",

  // Asset references (public, HTTPS-safe in production)
  logo: HARBORWELL_LOGO_PATH,    // full lockup, use in headers
  mark: HARBORWELL_MARK_PATH,    // square mark, use in tight spaces
  logoAlt: "HarborWell",         // accessible alternative text

  // Public contact / links
  supportEmail: "contact@harborwell.care",
  website: "https://www.harborwell.care",

  // Brand palette (mirrors design tokens already used across the app)
  colors: Object.freeze({
    navy: "#1E3A8A",              // primary
    slate: "#0F172A",              // heading ink
    body: "#334155",               // body ink
    sage: "#7E937D",               // supporting green
    canvas: "#F9F8F6",             // page canvas
    hairline: "#E5E5E0",           // subtle border
    amber: "#F59E0B",              // accent eyebrow
  }),
});

// Backwards-compatibility re-exports — do not add new consumers here.
// Import { BRAND } from "@/lib/brandingConfig" in new code instead.
export const HARBORWELL_LOGO = HARBORWELL_LOGO_PATH;
export const HARBORWELL_MARK = HARBORWELL_MARK_PATH;

export default BRAND;
